import React, { useState } from 'react';
import DesktopTabPanels from './DesktopTabPanels';
import MobileTabPanels from './MobileTabPanels';
import { DesktopOnlyDiv, FullWidthBackground, MobileOnlyDiv } from './styles';
import { TabPanelsProps } from './types';

const TabPanels: React.FC<TabPanelsProps> = ({
  tabPanels,
  showColouredBackground,
  onClick,
}) => {
  const [currentTabIndex, setCurrentTabIndex] = useState<number>(0);
  return (
    <FullWidthBackground colouredBackground={!!showColouredBackground}>
      <DesktopOnlyDiv data-testid="Desktop-panel-div">
        <DesktopTabPanels
          tabPanels={tabPanels}
          onClick={onClick}
          currentTabIndex={currentTabIndex}
          setCurrentTabIndex={setCurrentTabIndex}
        />
      </DesktopOnlyDiv>
      <MobileOnlyDiv data-testid="Mobile-panel-div">
        <MobileTabPanels
          tabPanels={tabPanels}
          onClick={onClick}
          currentTabIndex={currentTabIndex}
          setCurrentTabIndex={setCurrentTabIndex}
        />
      </MobileOnlyDiv>
    </FullWidthBackground>
  );
};

export default TabPanels;
